// Externe Bibliotheken
import React, { Component } from 'react';
import { NavLink } from 'react-router';

// Interne Module
import * as storage from '@/_helper/storage';
import { affiliateSkeleton } from '@/_helper/loadingState';

// Komponenten
import LoadingCircle from '@/comp/loadingOffersBar/LoadingCircle';
import Button from '@/comp/button/button';

// Styles
import '../claimUploadForm/claimUploadForm.scss';
import '../claimForm/claimForm.scss';
import './claimReviewForm.scss';

class ClaimReviewForm extends Component {
    state = {
        dataReturnTree: {},
        dataTree: {},
        isLoading: true,
        dataElements: [],
        formErrors: {
            agb: '',
            privacy: '',
        },
        formValid: false,
        filesUploadCount: 0,
    };

    uploadTypeTranslation = {
        fault: 'Mängelprotokoll',
        check24: 'Einzelverbindungsnachweis',
        luggage: 'PIR',
        general: 'Fotos',
    };

    serviceTranslation = {
        Luggage: 'Gepäck',
        OutboundFlight: 'Hinflug',
        OutboundTransfer: 'Hintransfer',
        Accommodation: 'Unterkunft',
        InboundTransfer: 'Rücktransfer',
        InboundFlight: 'Rückflug',
        Others: 'Sonstiges',
    };

    constructor(props) {
        super(props);
        this.bookingId = storage.get('bookingNumber');
        this.bookingData = storage.get('bookingData');
        this.TreeSection = this.TreeSection.bind(this);
        this.Question = this.Question.bind(this);
        this.Submit = this.Submit.bind(this);
        this.RecursiveFunction = this.RecursiveFunction.bind(this);
        this.state.dataTree = this.props.dataTree !== undefined ? this.props.dataTree : null;
        this.state.dataReturnTree = this.props.dataReturnTree !== undefined ? this.props.dataReturnTree : null;
        this.state.isLoading = false;
        this.state.contactData = this.props.contactData !== undefined ? this.props.contactData : null;
        this.state.files = this.props.files !== undefined && this.props.files;
    }

    handleSubmit(event) {
        event.preventDefault();

        if (!window.$affiliate) {
            let agb, privacy;
            agb = !event.target?.agb.checked;
            privacy = !event.target?.privacy.checked;

            if (agb === true || privacy === true) {
                this.setState({
                    formErrors: {
                        agb: agb,
                        privacy: privacy,
                    },
                    formValid: false,
                });
                return false;
            }
        }
        this.setState({
            isLoading: true,
        });

        let uploadError = false;

        this.uploadFiles()
            .then((files) => {
                // set : count of files upload
                this.setState({
                    filesUploadCount: files.length,
                });

                this.uploadDataTree().catch(() => {
                    uploadError = true;
                    this.setState({
                        formValid: false,
                        isLoading: false,
                    });
                    // Fehler beim Upload der Dateien
                    this.props.changeStep(4);
                });
            })
            .catch(() => {
                uploadError = true;
                this.setState({
                    formValid: false,
                    isLoading: false,
                });
                // Fehler beim Upload der Dateien
                this.props.changeStep(4);
            });

        if (uploadError) {
            // Fehler beim Upload der Dateien
            this.props.changeStep(4);
        }
    }

    async uploadFiles() {
        return fetch(`${window.$serviceUrl}/claim/purgeUploadFolder?token=${window.$token}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uploadId: this.bookingId }),
        })
            .then((response) => (response.ok ? Promise.resolve() : Promise.reject()))
            .then(() => {
                if (this.props.files !== undefined) {
                    let promises = [];
                    for (const name of Object.keys(this.props.files)) {
                        const parts = name.split('_');
                        let fileName = this.serviceTranslation[parts[0]] || parts[0];
                        for (let i = 1; i < parts.length; i++) {
                            if (i === parts.length - 1) {
                                fileName += '_' + (this.uploadTypeTranslation[parts[i]] || parts[i]);
                            } else {
                                fileName += '_' + parts[i];
                            }
                        }
                        const questionKey = parts[0];
                        for (const file of this.props.files[name]) {
                            const formData = new FormData();
                            formData.set('uploadId', this.bookingId);
                            formData.set('questionKey', questionKey);
                            formData.set('service', `${fileName}`);
                            formData.set('file', file);
                            promises.push(
                                fetch(`${window.$serviceUrl}/claim/uploadFiles?token=${window.$token}`, {
                                    method: 'POST',
                                    body: formData,
                                })
                                    .then((response) => (response.ok ? Promise.resolve() : Promise.reject()))
                                    .catch(() => {
                                        this.props.changeStep(4);
                                        return Promise.reject();
                                    })
                            );
                        }
                    }

                    return Promise.all(promises);
                }
            })
            .catch((error) => {
                // Dateien konnten nicht hochgeladen werden
                this.props.changeStep(4);
                return Promise.reject();
            });
    }

    async uploadDataTree() {
        return fetch(`${window.$serviceUrl}/pushComplaintTree/${this.bookingId}?token=${window.$token}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.props.dataTree),
        })
            .then((response) => (response.ok ? Promise.resolve() : Promise.reject()))
            .then(() => {
                let mode = 'web';
                if (storage.get('mode') !== null) {
                    mode = storage.get('mode');
                }

                return fetch(
                    `${window.$serviceUrl}/pushComplaintCustomerCase/${this.bookingId}?token=${window.$token}`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            mode: mode,
                            affiliate: window.$affiliate === 'ch24',
                            givenEmail: this.state.contactData.email,
                            tree: this.props.dataReturnTree,
                            filesUploadCount: this.state.filesUploadCount,
                        }),
                    }
                )
                    .then((response) => (response.ok ? Promise.resolve() : Promise.reject()))
                    .then(() => {
                        window.$claimEnabled = 'false';
                        this.setState({
                            isLoading: false,
                        });

                        // Rekla Kachel wird deaktiviert
                        if (this.bookingData && this.bookingData.data !== null && this.bookingData.data !== undefined) {
                            this.bookingData.data.allowClaim = false;
                            storage.set('bookingData', this.bookingData);
                        }

                        this.props.setSendForm(true);
                        this.props.changeStep(4);
                    })
                    .catch(() => {
                        // Fehler beim Upload der Daten
                        this.props.changeStep(4);
                        return Promise.reject();
                    });
            })
            .catch(() => {
                // Fehler beim Upload der Daten
                this.props.changeStep(4);
                return Promise.reject();
            });
    }

    changeFormValid(e) {
        let checked = !!e.currentTarget.checked;
        let targetName = e.target.name;

        this.setState((state) => {
            state.formErrors[targetName] = !checked;

            state.formValid = state.formErrors['agb'] === false && state.formErrors['privacy'] === false;
            return state;
        });
    }

    render() {
        const mainTreeSections = [];
        if (this.state.dataReturnTree && this.state.dataTree) {
            Object.keys(this.state.dataReturnTree).forEach((entryPoint) => {
                mainTreeSections.push(
                    <this.TreeSection
                        key={entryPoint}
                        tree={this.state.dataTree.EntryPoint[entryPoint]}
                        treeKey={this.state.dataTree.EntryPoint[entryPoint].key}
                    />
                );
            });
        }

        // File uploads
        let fileUploadFileList = '';
        let files = [];
        Object.keys(this.state.files).forEach((item) => {
            Object.keys(this.state.files[item]).forEach((index) => {
                files.push(<li key={item + index}>{this.state.files[item][index].name}</li>);
            });
        });

        if (!this.state.files || files.length === 0) {
            fileUploadFileList = (
                <div className="subbox panel">
                    <h4 className="question">Sie haben keine Nachweise eingereicht.</h4>
                </div>
            );
        } else {
            fileUploadFileList = (
                <div className="subbox panel">
                    <h4 className="question">Diese Dokumente haben Sie hochgeladen:</h4>
                    <ul>{files}</ul>
                </div>
            );
        }

        mainTreeSections.push(
            <div className="article" key="nachweise">
                <div className="container">
                    <h2 className="icon-file-description">Ihre Nachweise</h2>
                    {fileUploadFileList}
                </div>
            </div>
        );

        if (window.$affiliate !== 'ch24' && this.state.contactData) {
            // Kontaktdaten
            mainTreeSections.push(
                <div className="article" key={'contact'}>
                    <div className="container">
                        <h2 className="icon-account">Ihre Kontaktdaten</h2>
                        <div className="subbox panel">
                            <h4 className="question">Unter dieser E-Mail Adresse werden wir uns bei Ihnen melden:</h4>
                            <ul>{this.state.contactData.email}</ul>
                        </div>
                    </div>
                </div>
            );
        }

        return !this.state.isLoading ? (
            <>
                <section className="content-wrapper">
                    <div className="intro row">
                        <div className="intro-title">
                            <h1>Ihre Zusammenfassung der Reklamation</h1>
                        </div>
                        <div className="intro-text">
                            <p>
                                Fast geschafft! Hier können Sie noch einmal Ihr Angaben überprüfen, bevor Sie das
                                Formular abschicken.
                            </p>
                        </div>
                    </div>
                </section>

                {/* FORM */}
                <form onSubmit={(event) => this.handleSubmit(event)}>
                    <section className="section-review-step section-submit">
                        {mainTreeSections}

                        <div className="container agb-container">
                            {!window.$affiliate && (
                                <>
                                    <div className="row agb-input">
                                        <input
                                            type="checkbox"
                                            name="agb"
                                            id="agb-checkbox"
                                            onChange={(e) => {
                                                this.changeFormValid(e);
                                            }}
                                        />
                                        <label htmlFor="agb-checkbox">
                                            Wir weisen darauf hin, dass dieses Formular nur ein Mal abgesendet werden
                                            kann. Bitte prüfen Sie daher Ihre Angaben ein letztes Mal auf Richtigkeit
                                            und Vollständigkeit.
                                        </label>
                                    </div>
                                    <div className="row privacy-input">
                                        <input
                                            type="checkbox"
                                            name="privacy"
                                            id="privacy-checkbox"
                                            onChange={(e) => {
                                                this.changeFormValid(e);
                                            }}
                                        />
                                        <label htmlFor="privacy-checkbox">
                                            Durch das Absenden Ihrer Daten sind Sie damit einverstanden, dass wir Sie zu
                                            Ihrer Reklamation kontaktieren. Außerdem stimmen Sie zu, dass wir Ihre Daten
                                            nach Datenschutzrechtlinien speichern und verarbeiten. Hier finden Sie
                                            unsere{' '}
                                            <NavLink to="/datenschutz" target="_blank">
                                                Datenschutzhinweise
                                            </NavLink>{' '}
                                            und{' '}
                                            <a
                                                href={`${window.$website}/unternehmen/agb`}
                                                target="_blank"
                                                rel="noopener noreferrer">
                                                AGB
                                            </a>
                                            .
                                        </label>
                                    </div>
                                    {(this.state.formErrors['agb'] === true ||
                                        this.state.formErrors['privacy'] === true) && (
                                        <p className="error">
                                            Um das Formular abschicken zu können, müssen Sie die Datenschutzhinweise und
                                            Allgemeinen Geschäftsbedingungen akzeptieren.
                                        </p>
                                    )}
                                </>
                            )}
                            <div className="row button-container">
                                {window.$affiliate === 'ch24' &&
                                typeof this.bookingData.data?.pbeCustomerEmail === 'string' ? (
                                    <button
                                        className="button-back"
                                        onClick={() => {
                                            this.props.changeStep(1);
                                        }}>
                                        &lsaquo;&lsaquo; Zurück zu den Nachweisen
                                    </button>
                                ) : (
                                    <button
                                        className="button-back"
                                        onClick={() => {
                                            this.props.changeStep(2);
                                        }}>
                                        &lsaquo;&lsaquo; Zurück zu den Kontaktdaten
                                    </button>
                                )}
                                <this.Submit key="submit" />
                            </div>
                        </div>
                    </section>
                </form>
            </>
        ) : (
            <>{window.$affiliate !== 'ch24' ? <LoadingCircle /> : affiliateSkeleton()}</>
        );
    }

    TreeSection(args) {
        const tree = args.tree;
        const treeKey = args.treeKey;

        const elements = [];
        let endFor = false;
        if (this.state.dataReturnTree[treeKey] !== undefined) {
            Object.keys(this.state.dataReturnTree[treeKey].questions).forEach((item, i) => {
                if (!endFor) {
                    Object.keys(this.state.dataReturnTree[treeKey].questions[item].answers).forEach((answer) => {
                        let newTree = treeKey !== 'Others' ? tree.question.answers[answer] : '';

                        if (newTree !== undefined && newTree !== '') {
                            let newTreeName = newTree.name.replaceAll(' ', '-');
                            elements.push(
                                <div className="article" key={args.treeKey}>
                                    <div className="container">
                                        <h2 key={i} className={'icon-' + tree.key + ' categoryText'}>
                                            {tree.name} - {newTree.name}
                                        </h2>
                                        {this.RecursiveFunction(
                                            this.state.dataReturnTree[treeKey][newTreeName],
                                            tree.question.answers[answer],
                                            treeKey,
                                            newTree.name
                                        )}
                                    </div>
                                </div>
                            );
                        } else if (!endFor) {
                            endFor = true;
                            elements.push(
                                <div className="article" key={args.treeKey}>
                                    <div className="container">
                                        <h2 key={i} className={'categoryText icon-' + tree.key}>
                                            {tree.name}
                                        </h2>
                                        {this.RecursiveFunction(
                                            this.state.dataReturnTree[treeKey],
                                            tree,
                                            treeKey,
                                            'Sonstiges'
                                        )}
                                    </div>
                                </div>
                            );
                        }
                    });
                }
            });
        }

        return <React.Fragment key={args.treeKey + 'group'}>{elements}</React.Fragment>;
    }

    RecursiveFunction(returnTree, dataTree, treeKey, notShow) {
        let entrySection = [];
        let idStack = [];
        if (returnTree !== undefined) {
            Object.keys(returnTree).forEach((item, index) => {
                if (returnTree[item] !== undefined) {
                    if (item !== 'questions' && !item.includes('question')) {
                        idStack.forEach((id) => {
                            if (dataTree.question.type === 'multipleChoice') {
                                if (
                                    dataTree.question.answers[id] &&
                                    (dataTree.question.answers[id].name === item ||
                                        this.props.escapeString(dataTree.question.answers[id].name) === item)
                                ) {
                                    entrySection.push(
                                        this.RecursiveFunction(
                                            returnTree[item],
                                            dataTree.question.answers[id],
                                            item,
                                            notShow
                                        )
                                    );
                                }
                            } else {
                                if (dataTree.question.answers[id]) {
                                    dataTree = dataTree.question.answers[id];
                                    entrySection.push(
                                        this.RecursiveFunction(returnTree[item], dataTree, treeKey, notShow)
                                    );
                                }
                            }
                        });
                    } else {
                        Object.keys(returnTree[item]).forEach((eQuestion) => {
                            let tempDataTree = dataTree;
                            Object.keys(returnTree[item][eQuestion]['answers']).forEach((answer, i) => {
                                if (tempDataTree !== undefined && tempDataTree.isEnd !== true) {
                                    tempDataTree = tempDataTree.question.answers[answer];
                                }
                                idStack.push(answer);
                                if (
                                    dataTree !== undefined &&
                                    dataTree.question !== undefined &&
                                    dataTree.question.answers !== undefined &&
                                    dataTree.question.answers[answer] !== undefined &&
                                    dataTree.question.answers[answer].isEnd === false
                                ) {
                                    let questionObj = dataTree;
                                    let question = questionObj.question;
                                    entrySection.push(
                                        <div className="subbox panel" key={`box-${treeKey + answer}`}>
                                            <this.Question
                                                key={treeKey + eQuestion}
                                                index={i}
                                                notShow={notShow}
                                                questionKey={eQuestion}
                                                treeKey={treeKey}
                                                subKey={dataTree.name}
                                                question={question}
                                                isEnd={questionObj.isEnd}
                                                tree={returnTree}
                                            />
                                        </div>
                                    );
                                }
                            });
                        });
                    }
                }
            });
        }
        return entrySection;
    }

    Submit() {
        return <Button type="submit" label="Reklamation jetzt abschicken" />;
    }

    Question(args) {
        let Question = [];
        if (args.tree !== undefined && args.question !== undefined && args.question.type === 'multipleChoice') {
            if (args.index === 0) {
                return null;
            }
            let answerTree = args.tree;
            let answers = answerTree.questions[args.question.key].answers;
            let answer = [];
            Question.push(
                <h4 key={args.treeKey + args.questionKey + 'question'} className="question">
                    {args.question.name}
                </h4>
            );

            let length = Object.keys(answers).length;
            Object.keys(answers).forEach((answerKey, index) => {
                answer.push(args.question.answers[answerKey].name);
                if (length - 1 !== index) {
                    answer.push(', ');
                }
            });

            Question.push(
                <div key={args.treeKey + args.questionKey + 'answer'} className="answer">
                    {answer}
                </div>
            );
        } else if (args.tree !== undefined && args.question !== undefined) {
            if (args.subKey !== undefined && args.notShow !== args.subKey) {
                Question.push(<h3 key={args.treeKey + args.subKey}>{args.subKey}</h3>);
            }
            let answerTree = args.tree;
            let answers = answerTree.questions[args.question.key].answers;
            if (args.question.type !== 'amountField') {
                Question.push(
                    <h4 key={args.treeKey + args.questionKey + 'question'} className="question">
                        {args.question.name}
                    </h4>
                );
            }

            let answer = [];
            Object.keys(answers).forEach((answerKey) => {
                if (args.question.type === 'freeText') {
                    answer.push(answers[answerKey]);
                } else if (args.question.type === 'dateRange') {
                    if (args.question.answers[answerKey].isEnd) {
                        answer.push(answers[answerKey] + ' bis ');
                    } else {
                        answer.push(answers[answerKey]);
                    }
                } else if (args.question.type === 'datePicker') {
                    answer.push(answers[answerKey]);
                } else if (
                    args.question.answers[answerKey].question &&
                    args.question.answers[answerKey].question.type === 'amountField'
                ) {
                } else if (args.question.type === 'amountField') {
                    answer.push('Ja, ' + answers[answerKey]);
                } else if (args.question.type === 'minuteField') {
                    answer.push(this.formatMinutesToHours(answers[answerKey]));
                } else {
                    if (args.question.answers[answerKey] !== undefined) {
                        answer.push(args.question.answers[answerKey].name);
                    }
                }

                if (
                    args.question.answers[answerKey] !== undefined &&
                    (args.question.type !== 'dateRange' ||
                        (args.question.type === 'dateRange' &&
                            args.question.answers[answerKey] &&
                            !args.question.answers[answerKey].isEnd)) &&
                    (!args.question.answers[answerKey].question ||
                        (args.question.answers[answerKey].question &&
                            args.question.answers[answerKey].question.type !== 'amountField'))
                ) {
                    Question.push(
                        <div key={args.treeKey + args.questionKey + 'answer'} className="answer">
                            {answer}
                        </div>
                    );
                }

                if (
                    !args.question.answers[answerKey].isEnd &&
                    args.question.answers[answerKey].question !== undefined &&
                    args.question.type !== 'multipleChoice'
                ) {
                    let questionObj = args.question.answers[answerKey];
                    let questionKey = questionObj.question.key;
                    let question = questionObj.question;
                    Question.push(
                        <this.Question
                            key={args.treeKey + questionKey}
                            questionKey={questionKey}
                            treeKey={args.treeKey}
                            question={question}
                            tree={answerTree}
                        />
                    );
                }
            });
        }
        return Question;
    }

    formatMinutesToHours(value) {
        let returnString = '';

        for (var i = 0; i < 4; i++) {
            if (i === 0) {
                if (value < 600) {
                    returnString += '0';
                } else {
                    returnString += Math.floor(parseInt(value) / 60)
                        .toString()
                        .charAt(0);
                }
            }
            if (i === 1) {
                if (value < 60) {
                    returnString += '0';
                } else {
                    let tempValue = Math.floor(parseInt(value) / 60).toString();
                    returnString += tempValue.length < 2 ? tempValue : tempValue.charAt(1);
                }
            }
            if (i === 2) {
                returnString += ' Std. ';
                returnString += ((parseInt(value) % 60) * 10).toString().charAt(0);
            }
            if (i === 3) {
                let tempValue = ((parseInt(value) % 60) * 10).toString();
                returnString += tempValue.length < 2 ? tempValue : tempValue.charAt(1);
                returnString += ' Min. ';
            }
        }

        return returnString;
    }
}

export default ClaimReviewForm;
